"use strict";

(() => {
    const initializeQuantitySelector = () => {
        const quantityWrapper = document.querySelector('.product-info__quantity-selector__options');
        const quantityInput = document.querySelector('.quantity-selector input[name="quantity"]');
    
        if (!quantityWrapper || !quantityInput) return;
    
        const clone = quantityWrapper.cloneNode(true);
        quantityWrapper.parentNode.replaceChild(clone, quantityWrapper);
    
        let currentTarget = clone.querySelector('.product-info__quantity-selector__option.active') || null;
    
        clone.addEventListener('click', (e) => {
            const quantityOption = e.target.closest('.product-info__quantity-selector__option');
        
            if (!quantityOption || !clone.contains(quantityOption)) return;
        
            const quantityInput = document.querySelector('.product-info__quantity-selector .quantity-selector input[name="quantity"]');
            if (!quantityInput) return;
        
            const quantity = quantityOption.dataset.itemQuantity;
            if (!quantity) return;
    
            quantityInput.value = quantity;
        
            if (currentTarget && currentTarget !== quantityOption) {
                currentTarget.classList.remove('active');
            }
        
            quantityOption.classList.add('active');
            currentTarget = quantityOption;

            const sealsUnitPrice = document.querySelector('.sls-price .money.conversion-bear-money');
            const currentOptionUnitPrice = currentTarget.querySelector('.product-info__quantity-selector__unit-price span');
            const sealsSingleOption = document.querySelector('.sls-option-container:first-of-type');

            if(sealsUnitPrice && currentOptionUnitPrice) {
                sealsUnitPrice.innerHTML = currentOptionUnitPrice.innerHTML;
            }

            if(!sealsSingleOption || window.observerMounted) return;

            const observer = new MutationObserver(() => {
                const sealsUnitPrice = document.querySelector('.sls-price .money.conversion-bear-money');
                const currentOptionUnitPrice = currentTarget.querySelector('.product-info__quantity-selector__unit-price span');

                sealsUnitPrice.innerHTML = currentOptionUnitPrice.innerHTML;
            });

            observer.observe(sealsSingleOption, { attributes: true, subtree: true });

            window.observerMounted = true;
        });
    };
    
    initializeQuantitySelector();
    
    let currentUrl = location.href;
    
    const checkForVariantChange = () => {
        if (location.href !== currentUrl) {
            currentUrl = location.href;
            setTimeout(() => {
                initializeQuantitySelector();
            }, 50);
        }
    };
    
    window.addEventListener('popstate', checkForVariantChange);
    
    ['pushState', 'replaceState'].forEach((method) => {
        const original = history[method];
        history[method] = function(...args) {
            const result = original.apply(this, args);
            checkForVariantChange();
            return result;
        };
    });
})();